<script setup lang="ts">
import LeChevronUp from "@dsk/icons/LeChevronUp.vue";
import { DisclosureButton } from "@headlessui/vue";

defineProps<{
  open: boolean;
}>();
</script>

<template>
  <DisclosureButton class="le-faq-button" :class="{ 'le-faq-button--open': open }">
    <span>
      <slot />
    </span>
    <LeChevronUp class="le-faq-button__icon" :class="{ 'le-faq-button__icon--open': open }" role="presentation" />
  </DisclosureButton>
</template>

<style scoped lang="less">
@import "@dsk/styles/all";

.le-faq-button {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 10px 16px;
  border: 0;
  border-radius: 4px;
  background-color: @colors[@neutrals][100];
  text-align: left;
  white-space: pre-line;
  .body-text("m");
  gap: 4px;

  #media-breakpoint-up(md, {
    padding: 16px 40px;
  });

  &:hover {
    background-color: @colors[@secondary][100];
  }

  &.focus-visible {
    .focus-outline(grey);
  }

  &--open {
    border-radius: 4px 4px 0 0;
    background-color: @colors[@accent][300];

    &:hover {
      background-color: @colors[@accent][400];
    }

    &.focus-visible {
      border-radius: 4px;
      .focus-outline(yellow);
    }
  }

  &__icon {
    min-width: 16px;
    min-height: 16px;
    transform: rotate(180deg);
    transition: all 100ms linear;

    &--open {
      transform: none;
    }
  }
}
</style>
